import React from "react";
import CardBasic from "../CardBasic";
import { ReactComponent as Trash } from "../../assets/icons/trash-01.svg";
import { ReactComponent as Pen } from "../../assets/icons/edit.svg";

export default function CardOutlet({
  i,
  data,
  editFunction,
  deleteFunction,
  isDisable,
}) {
  return (
    <CardBasic
      key={data.id}
      i={data.id}
      title={data?.name ? data?.name : data?.outlet?.name ?? "Outlet"}
      isDisable={isDisable}
      subtitle={data?.address ? data?.address : data?.outlet?.address}
      data={data}
    >
      <div className="px-3 py-3">
        <div className="flex justify-between">
          <button
            onClick={() => deleteFunction(i, data)}
            disabled
            className="flex items-center justify-center gap-2 rounded-lg border border-monochrome-100 bg-white px-3 py-1.5 text-xs  font-semibold text-monochrome-600 transition-colors disabled:bg-monochrome-50 disabled:text-monochrome-300"
          >
            <Trash />
            Hapus
          </button>
          <button
            disabled
            onClick={() => editFunction(data)}
            className="flex items-center justify-center gap-2 rounded-lg border border-monochrome-100 bg-white px-3 py-1.5 text-xs  font-semibold text-monochrome-600 transition-colors disabled:bg-monochrome-50 disabled:text-monochrome-300"
          >
            <Pen />
            Edit
          </button>
        </div>
      </div>
    </CardBasic>
  );
}
